import React from 'react';
import PropTypes from 'prop-types';
import Label from "semantic-ui-react/dist/es/elements/Label/Label.js";
import classnames from 'classnames';
import { getParagraphsFromStrings } from "../../../utils/get-paragraphs-from-strings";
import { buildKeyFromStrings } from "../../../utils/build-key-from-strings";
import { Icon } from "../Icon";
import { Paragraph } from "../../typography/Paragraph";
export var Component = function Component(_ref) {
  var isDisabled = _ref.isDisabled,
      isFilled = _ref.isFilled,
      isLeftAligned = _ref.isLeftAligned,
      label = _ref.label,
      name = _ref.name,
      size = _ref.size;
  return React.createElement(Label, {
    basic: !isFilled,
    className: classnames('icon-card', {
      'is-large': size === 'large',
      'left aligned': isLeftAligned
    })
  }, React.createElement(Icon, {
    isDisabled: isDisabled,
    name: name,
    size: "big"
  }), label && getParagraphsFromStrings(label).map(function (paragraph, index) {
    return React.createElement(Paragraph, {
      key: buildKeyFromStrings(paragraph, index)
    }, paragraph);
  }));
};
Component.displayName = 'IconCard';
Component.defaultProps = {
  isDisabled: false,
  isFilled: false,
  isLeftAligned: false,
  label: null,
  size: 'medium'
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  isDisabled: PropTypes.bool,
  isFilled: PropTypes.bool,
  isLeftAligned: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.oneOf(['medium', 'large'])
} : {};